import { jsx } from "react/jsx-runtime";
import { useBlockEnvironment, ApexForm } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const BlockApexForm = ({
  attrs,
  index,
  innerBlocks
}) => {
  const {
    environment = "prod"
  } = useBlockEnvironment();
  const defaultValues = getDefaultApexFieldValues(innerBlocks);
  const endpoint = environment === "prod" ? "https://zg-api.com/interested-party/submit" : "https://zg-api.test.zillow.net/interested-party/submit";
  return /* @__PURE__ */ jsx(ApexForm, { defaultValues, ...attrs, endpoint, children: generateBlockList({
    blocks: innerBlocks
  }) }, index);
};
function getDefaultApexFieldValues(innerBlocks) {
  const defaultValues = {};
  getDefaultApexFieldValuesHelper(innerBlocks, defaultValues);
  return defaultValues;
}
function getDefaultApexFieldValuesHelper(innerBlocks, defaultValues) {
  innerBlocks.forEach((innerBlock) => {
    if (innerBlock.blockName === "constellation/apex-field") {
      if (innerBlock.attrs.defaultValue) {
        defaultValues[innerBlock.attrs.formData] = innerBlock.attrs.defaultValue;
      }
    }
    getDefaultApexFieldValuesHelper(innerBlock.innerBlocks, defaultValues);
  });
}
BlockApexForm.propTypes = {
  index: PropTypes.number,
  id: PropTypes.string,
  attrs: PropTypes.shape({
    businessLine: PropTypes.string.isRequired,
    warmLeadSource: PropTypes.string.isRequired
  })
};
BlockApexForm.defaultProps = {
  id: void 0,
  index: void 0,
  attrs: {
    businessLine: "",
    warmLeadSource: ""
  }
};
export {
  BlockApexForm as default
};
